import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Optional, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { UiKitModule } from '@serviceplan/ui-kit';
import { AssetUIModel, ClientCoreModule, accessAsset } from '@thehubz/client/core';
import { CreateAssetDto } from '@thehubz/client/data-access-api';
import { AnyType } from '@thehubz/shared/model';
import { AssetHtmlBannerComponent } from '../components/asset-detail-view/asset-info/components/asset-html-banner/asset-html-banner.component';
import { AssetImageComponent } from '../components/asset-detail-view/asset-info/components/asset-image/asset-image.component';
import { AssetPdfComponent } from '../components/asset-detail-view/asset-info/components/asset-pdf/asset-pdf.component';
import { AssetPowerPointComponent } from '../components/asset-detail-view/asset-info/components/asset-power-point/asset-power-point.component';
import { AssetVideoComponent } from '../components/asset-detail-view/asset-info/components/asset-video/asset-video.component';
import { AssetCommonService } from '../services/asset-common.service';

@Component({
  selector: 'thehubz-asset-full-screen',
  templateUrl: './asset-full-screen.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    ClientCoreModule,
    UiKitModule,
    AssetImageComponent,
    AssetHtmlBannerComponent,
    AssetPdfComponent,
    AssetVideoComponent,
    AssetPowerPointComponent,
  ],
})
export class AssetFullScreenComponent implements OnInit {
  @Input() data!: AssetUIModel;
  @Output() isExpanded = new EventEmitter<boolean>();
  viewHeader = false;
  externalUserFlag = false;
  moduleName = 'Library';
  AssetTypes = CreateAssetDto.AssetTypeEnum;

  AccessAsset = accessAsset;

  constructor(
    @Optional() public dialogRef: MatDialogRef<AssetFullScreenComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: AnyType,
    protected assetCommonService: AssetCommonService,
  ) {}

  ngOnInit(): void {
    this.data = this.data ? this.data : this.dialogData;
    this.viewHeader = this.dialogData.viewHeader;
    if (this.data && this.data['externalUserFlag']) {
      this.externalUserFlag = true;
      this.moduleName = '';
    }
  }

  closeFullScreen() {
    this.dialogRef.close('closed');
  }
}
